import type { Logger } from "@expert/logging";

import { type ExWoMetricData, sendMetrics } from "./sendMetrics";

export interface WithMetricsOptions {
    logger: Logger;
    rethrow?: boolean;
    logResult?: boolean;
    failureLogLevel?: "error" | "warn";
}

export const withMetricsDimensionName = "actionName";

export async function withMetrics<T>(
    actionName: string,
    action: () => Promise<T>,
    { logger, rethrow = true, logResult = true, failureLogLevel = "warn" }: WithMetricsOptions,
) {
    const localLogger = logger.child({ actionName });
    const metricData: ExWoMetricData = { metrics: [], dimensions: { [withMetricsDimensionName]: actionName } };
    try {
        localLogger.debug(`Starting ${actionName}...`);
        metricData.metrics.push({ name: "Start", value: 1 });
        const startExecution = performance.now();
        const result = await action();
        const duration = performance.now() - startExecution;
        localLogger.info(
            { duration, result: logResult && result },
            `${actionName} completed successfully in ${duration}ms.`,
        );
        metricData.metrics.push({ name: "Success", value: 1 });
        metricData.metrics.push({ name: "Duration", value: duration });
        return result;
    } catch (error) {
        localLogger[failureLogLevel]({ error }, "Action failed");
        metricData.metrics.push({ name: "Failure", value: 1 });
        if (rethrow) throw error;
    } finally {
        void sendMetrics([metricData]);
    }
}
